/* import __COLOCATED_TEMPLATE__ from './data.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  onNext?: () => void;
}

const StandaloneDeploySalesforceCasesData = templateOnlyComponent<Args>();
export default StandaloneDeploySalesforceCasesData;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Cases::Data': typeof StandaloneDeploySalesforceCasesData;
    'standalone/deploy/salesforce/cases/data': typeof StandaloneDeploySalesforceCasesData;
  }
}
